import { useEffect, useState } from 'react';

export interface UseScrollPositionOptions {
  bounds?: {
    min?: number;
    max?: number;
  };
}

export const useScrollPosition = ({ bounds }: UseScrollPositionOptions = {}): number => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const updatePosition = () => {
      let position =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (bounds?.max !== undefined && position >= bounds.max) {
        position = bounds.max;
      } else if (bounds?.min !== undefined && position <= bounds.min) {
        position = bounds.min;
      }

      setScrollPosition(position);
    };

    window.addEventListener('scroll', updatePosition);
    updatePosition();
    return () => window.removeEventListener('scroll', updatePosition);
  }, [bounds?.max, bounds?.min]);

  return scrollPosition;
};
